import { EnvironmentUrl } from './environment-url';
import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BaseCRUDService } from './BaseCRUDService';

@Injectable({
  providedIn: 'root',
})
export class UserService extends BaseCRUDService {
  constructor(http: HttpClient, envUrl: EnvironmentUrl) {
    super(http, envUrl, 'UserManagement');
  }
}
